import { createFileRoute } from '@tanstack/react-router';

import { ExtractionsPage } from '@/features/documents/extractions-page';

export const Route = createFileRoute('/_app/projects/$projectId/cost/scans/')({
  component: ScansRoute,
});

function ScansRoute() {
  const { projectId } = Route.useParams();
  return <ExtractionsPage projectId={projectId} />;
}
